import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-search-admin',
  templateUrl: './search-admin.component.html',
  styleUrls: ['./search-admin.component.scss']
})
export class SearchAdminComponent implements OnInit {
  searchText: string;
  fileCount: number;
  returnLink: string;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.subscribeToRouteParam();
  }

  private subscribeToRouteParam(): void {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.searchText = params.get('search');
      this.returnLink = params.get('return');
    });
  }

  setFileCount(count) {
    this.fileCount = count;
  }

  goBack() {
    this.router.navigate([this.returnLink], { relativeTo: this.route.parent });
  }

}
